import { Box, Stack, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ProfileTabs from "./ProfileTabs";
import { GradientBorderBox } from "../../../Components";

export default function ProfileLayout() {
  const theme = useTheme();
  const location = useLocation();
  const [imageChange, setImageChange] = useState(false);
  useEffect(() => {
    setImageChange((prev) => !prev);
  }, [location]);
  return (
    // Main Stack
    <Stack gap={{ xs: "2.5rem", lg: "5.5rem" }} pt={"3rem"} px={"2rem"}>
      {/* Tabs */}
      <ProfileTabs />

      {/* BackGround Stack */}
      <Stack
        sx={{
          position: "relative",
          borderRadius: "1.3rem",
          bgcolor: "transparent",
          mx: "auto",
          minWidth: {
            xs: "300px",
            sm: "420px",
            md: "520px",
            lg: "620px",
            xl: "720px",
            exl: "920px",
          },
          minHeight: {
            xs: "300px",
            sm: "420px",
            md: "520px",
            lg: "620px",
            xl: "720px",
            exl: "920px",
          },
          width: "100%",
          maxWidth: "1050px",
          padding: {
            xs: "1rem",
            md: "2rem",
            xl: "3rem",
          },
        }}
      >
        <Outlet />
        {/* ui images */}
        <Box
          sx={{
            display: { xs: "none", lg: "flex" },
            width: "250px",
            height: "250px",
            position: "absolute",
            zIndex: "-10",
            top: "-5px",
            left: imageChange ? "-0%" : "110%",
            transform: "translate(-70% , -20%)",
            transition: "all .3s",
          }}
        >
          <img
            style={{ width: "100%", height: "100%" }}
            src="/Media/Circles/circle.svg"
            alt="pretty-corner"
          />
        </Box>
        {/* ui images */}
        <Box
          sx={{
            display: { xs: "none", lg: "flex" },
            width: "350px",
            height: "350px",
            position: "absolute",
            zIndex: "-10",
            bottom: "3rem",
            right: imageChange ? "0%" : "110%",
            transform: "translate(-70% , -20%)",
            rotate: "180deg",
            transition: "all .3s",
          }}
        >
          <img
            style={{ width: "100%", height: "100%" }}
            src="/Media/Circles/circle.svg"
            alt="pretty-corner"
          />
        </Box>

        <GradientBorderBox
          bgGrad={`linear-gradient(
    ${imageChange ? "-150deg" : "150deg"},
    ${theme.palette.primary.main} -30%,
    ${theme.palette.background.default} 40%,
    ${theme.palette.background.default} 60%,
     ${theme.palette.background.white} 100%
  )`}
        />
      </Stack>
    </Stack>
  );
}
